import { Star } from "lucide-react";

const testimonials = [
  {
    quote:
      "Sprig Built made the whole thing painless. I finally have a site I'm proud to share, and people are finding our contractors online.",
    name: "Daniel R.",
    role: "Owner, Kootenay Home Pros",
    img: "https://images.pexels.com/photos/10816007/pexels-photo-10816007.jpeg",
  },
  {
    quote:
      "They captured our brand perfectly — warm, friendly and easy to book. New clients tell us the website is what won them over.",
    name: "Kat M.",
    role: "Founder, Fetch Pups",
    img: "https://static.wixstatic.com/media/7cc6fc_ef53027400084769ba27c4d4de0b7176~mv2.jpg/v1/fill/w_218,h_214,al_c,q_80,enc_auto/Kat%20Maguire%20Fetch%20Pups%20Founder%202023_edited_edited.jpg",
  },
  {
    quote:
      "Affordable, fast and genuinely kind people. Our cleaning business looks professional now and the bookings keep coming in.",
    name: "Spotless Cleanrz",
    role: "Cleaning services",
    img: "https://static.wixstatic.com/media/7cc6fc_037d4b4d1cac4c34901cbab61708aab6~mv2.png/v1/fill/w_200,h_200,al_c,q_85,enc_auto/7cc6fc_037d4b4d1cac4c34901cbab61708aab6~mv2.png",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 sm:py-32">
      <div className="mx-auto max-w-6xl px-6 sm:px-12">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#75C69F]">
            Loved by local owners
          </span>
          <h2 className="mt-4 font-heading text-4xl font-medium tracking-tight text-[#0B281B] sm:text-5xl">
            Don't just take our word for it.
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="rounded-3xl border border-[#DCECE3] bg-white p-8"
            >
              <div className="flex gap-1">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} className="h-4 w-4 fill-[#75C69F] text-[#75C69F]" />
                ))}
              </div>
              <p className="mt-5 text-lg leading-relaxed text-[#0B281B]">
                "{t.quote}"
              </p>
              <div className="mt-6 flex items-center gap-3">
                <img
                  src={t.img}
                  alt={t.name}
                  className="h-11 w-11 rounded-full object-cover"
                />
                <div>
                  <p className="font-medium text-[#0B281B]">{t.name}</p>
                  <p className="text-sm text-[#4A6657]">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
